import React from 'react';

export const ONETRUST_SCRIPT_DEFAULT_TYPE = 'text/plain';

export const TEST = '-test';

export const PAGES_WITHOUT_OVERLAY = [
  '/cookie-policy',
  '/privacy-policy',
  '/terms',
];

export const PREVENT_ONETRUST_OVERLAY_CSS = (
  <style type="text/css">
    {'body .onetrust-pc-dark-filter {display: none !important;}'}
  </style>
);
